import { makeHasEnded } from '@/competitions/_common/utils.ts';

import { MAY_2025_CAMPAIGN_END_DATE } from '../../../config.ts';

export const useHasEnded = makeHasEnded(MAY_2025_CAMPAIGN_END_DATE);
